//公共配置文件
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

console.log('host',host)
import config from './config'

var state = {
  isToken:config[host].isToken,  //是否包含token
  i18n:{},
  title:'',
  dataurl:'',
  cnzz:config[host].cnzz,   //cnzz 统计地址
  lang:config[host].lang,   //语言 zh en
  color:config[host].color, //ui的默认颜色
  imageList:config[host].imageList, //{name:'library_group'}, //拉花图库路由对象  false,就是没有
  device_code:21937163,//设备号转换代码

}

let store = new Vuex.Store({
    state
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js